import React, { Component } from "react";
import "../footer/footer.css";
import { FaInstagram } from "react-icons/fa";

export default class footer extends Component {
  render() {
    return (
      <div>
        <center>
          
          <div className="footerdiv">
            <footer className="footer_text">
              <label className="copyright">
                <br />
              </label>
              <label className="soc_acc_txt">
                
                |
                < a href = "https://bit.ly/34YEG6y"
                target = "_blank" >
                  {" "}
                  <FaInstagram /> C-Walk Sanju
                </a>{" "}
                |
               
              </label>
            </footer>
          </div>
        </center>
      </div>
    );
  }
}
